import { render, staticRenderFns } from "./SessionExpiredDialog.vue?vue&type=template&id=bbb47ea2"
import script from "./SessionExpiredDialog.vue?vue&type=script&lang=js"
export * from "./SessionExpiredDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports